import { render, staticRenderFns } from "./FormCourseGroupSelect.vue?vue&type=template&id=cda30a2a&scoped=true&"
import script from "./FormCourseGroupSelect.vue?vue&type=script&lang=js&"
export * from "./FormCourseGroupSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormCourseGroupSelect.vue?vue&type=style&index=0&id=cda30a2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda30a2a",
  null
  
)

export default component.exports